export const SkeletonLoadingConfig = {
  width: 120,
  height: 100,
  amount: 9,
};
